"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "collio": {
    "83930829": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "beretta": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50377851": [{
      "hkey": "1f32c1cb",
      "slug": "busana",
      "name": "Busana",
      "primary": true,
      "skipSearch": false
    }],
    "fonte-busana": [{
      "hkey": "1f32c1cb",
      "slug": "busana",
      "name": "Busana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a7d3db61": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "ivino": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b034cc26": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "naani": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61d8d08f": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "par-paes": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f97f483f": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "pezzeda": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61646d68": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "roncheo": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c9ceb0e": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07eae385": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "scaletti": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4fe8aa4b": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "skipSearch": false
    }],
    "seramando": [{
      "hkey": "5504ea2a",
      "slug": "collio",
      "name": "Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;